var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Auge__Icn/40px/Auge",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Auge__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Auge__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,14 C23.7555363,14 27.1555363,16 30.2,20 C27.1555363,24 23.7555363,26 20,26 C16.2444637,26 12.8444637,24 9.8,20 C12.8444637,16 16.2444637,14 20,14 Z M20,16 C17.4087102,16 14.978779,17.1912012 12.6651433,19.6886814 L12.383,20 L12.4085489,20.0284394 C14.713632,22.6228388 17.1333415,23.9066971 19.7127406,23.9950921 L20,24 C22.5912898,24 25.021221,22.8087988 27.3348567,20.3113186 L27.616,20 L27.5914511,19.9715606 C25.286368,17.3771612 22.8666585,16.0933029 20.2872594,16.0049079 L20,16 Z M20,17 C21.6568542,17 23,18.3431458 23,20 C23,21.6568542 21.6568542,23 20,23 C18.3431458,23 17,21.6568542 17,20 C17,18.3431458 18.3431458,17 20,17 Z",
    id: ".._.._src_svg_Icn_40px_Auge__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuge);
export default __webpack_public_path__ + "static/media/Auge.7843ff3d2e3d6ee61cf1accf4d915c17.svg";
export { ForwardRef as ReactComponent };